const situations = [
  { title: 'Сотрудник игнорирует договорённости', desc: 'Обсуждали задачу, договорились о сроках — но сотрудник снова не выполнил. Как реагировать лидеру, а не просто «начальнику»?' },
  { title: 'Сильный специалист не принимает руководителя', desc: 'Сотрудник считает, что он компетентнее руководителя, и демонстрирует это в поведении. Как выстроить рабочие отношения?' },
  { title: 'Сотрудник спорит с решениями', desc: 'Публично или скрыто оспаривает решения руководителя. Как сохранить управляемость, не подавляя инициативу?' },
  { title: 'Команда сопротивляется изменениям', desc: 'Новые процессы, структура или задачи вызывают сопротивление. Как провести команду через изменения, не потеряв вовлечённость?' },
  { title: 'Сотрудник перестал проявлять инициативу', desc: 'Раньше предлагал идеи, а теперь просто выполняет минимум. Как вернуть вовлечённость?' },
  { title: 'Необходимо дать жёсткую обратную связь', desc: 'Сотрудник систематически не выполняет требования. Как провести разговор, чтобы он привёл к изменениям, а не к конфликту?' },
  { title: 'Необходимо принять непопулярное решение', desc: 'Решение, которое не понравится команде, но необходимо для бизнеса. Как объяснить его и сохранить доверие?' },
  { title: 'Между сотрудниками возникает конфликт', desc: 'Два ценных сотрудника не могут договориться. Как вмешаться, не усугубляя ситуацию и не выбирая сторону?' },
  { title: 'Руководитель сталкивается с открытым несогласием', desc: 'Сотрудник открыто выражает несогласие с позицией руководителя. Как ответить, чтобы сохранить авторитет и конструктивный диалог?' },
];

export default function DifficultSituations() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Лидерство в сложных ситуациях
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-10 max-w-3xl mx-auto leading-relaxed">
          Что делать руководителю, когда команда сопротивляется и возникают сложные управленческие ситуации
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {situations.map((s) => (
            <div key={s.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center mb-4">
                <i className="ri-alert-line text-amber-600 text-lg"></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center mx-auto mb-4">
            <i className="ri-lightbulb-line text-teal-700 text-xl"></i>
          </div>
          <p className="text-base text-gray-800 leading-relaxed font-semibold">
            Лидерство особенно хорошо проявляется не тогда, когда команда согласна со всем руководителем, а когда руководителю необходимо провести её через сложную ситуацию.
          </p>
        </div>
      </div>
    </section>
  );
}